import React from "react";
import Header from "../../Layout/Header/Header";
import Footer from "../../Layout/Footer/Footer";
import Prize_winners from "./Prize_winners";
import Poweredby_after from "../Powered-by/Poweredby_after";
import MainImage from "../../../Assets/img/Group 2515.png";
import Carousel from "react-multi-carousel";


const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};


function Prizes() {
  return (
    <div className="Prizes innerBody">
      <Header />

      <div className="container edition_slider">
          <div className="col-10 offset-md-1 text-center">
            <h3 className="title m-auto pt-4 pb-4">PRIZES</h3> 
            <p>Playing Puzzled is fun enough without any incentives . We just want to give you that extra bit of motivation to finish at the top. </p> <br/>
          </div>  
          {/* <Carousel responsive={responsive} >
            <div className="active"> <p> <a href="/prizes"> SUMMER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes">  WINTER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes">  SUMMER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes">  WINTER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes"> SUMMER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes">  SUMMER EDITION'20 </a> </p> </div>
            <div className="slider_box"> <p> <a href="/prizes"> SUMMER EDITION'20 </a> </p> </div>
          </Carousel> <br/> */}
      </div>
      <div className="container">
        <div className="row">
          <div className="banner text-center">
            <img src={MainImage} alt="" />
          </div>
        </div>

        <Prize_winners />

      </div>
      <div className="container-fluid bg-base mt-4">
        <div className="container">
          <div className="row">
            <div className="col pl-0 pr-0">
              <div className="card card-body border-0 o-hidden mb-0 text-light">
                <div className="position-relative flex-column flex-md-row align-items-center signup_now">
                  <div className="h3 text-center mb-md-0">
                    <span>Are you up for the challenge ?</span> Sign up now and
                    start inviting your friends   <a href="/register" className="btn btn-lg btn-yellow ml-5 mt-2 mb-2">
                    REGISTER
                  </a>
                  <a href="/invite-friends" className="btn btn-lg btn-yellow ml-2 mt-2 mb-2 invite_btn">
                    INVITE NOW
                  </a>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Poweredby_after />
      <Footer />
    </div>
  );
}

export default Prizes;
